import { render, staticRenderFns } from "./VerifiedPurchase.vue?vue&type=template&id=c726ffe0"
import script from "./VerifiedPurchase.vue?vue&type=script&lang=js"
export * from "./VerifiedPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports